import {
  Button,
  ButtonProps,
  CircularProgress,
  Typography,
} from "@mui/material";
import { FC } from "react";

interface ILoadingButtonProps extends ButtonProps {
  isLoading?: boolean;
}

export const LoadingButton: FC<ILoadingButtonProps> = ({
  isLoading,
  size = 20,
  children,
  type = "submit",
  ...rest
}) => {
  return (
    <Button type={type} {...rest}>
      <Typography
        sx={{
          opacity: isLoading ? 0 : 1,
        }}
      >
        {children}
      </Typography>
      {isLoading && (
        <CircularProgress
          size={size === "small" ? 20 : 24}
          color="inherit"
          sx={{
            position: "absolute",
            zIndex: 2,
          }}
        />
      )}
    </Button>
  );
};
